import React from 'react'
import { Helmet } from 'react-helmet'

export type SEOProps = {
  title: string
  image: {
    url: string
  }
  description: string
  keywords?: string
}

const SEO = ({ description, image, title, keywords = 'Íslandsstofa' }: SEOProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='og:title' property='og:title' content={title} />
      <meta name='description' property='description' content={description} />
      <meta name='og:description' property='og:description' content={description} />
      <meta name='twitter:description' content={description} />
      {keywords && <meta name='keywords' property='keywords' content={keywords} />}
      {image.url && <meta name='og:image' property='og:image' content={image.url} />}
      {image.url && <meta name='twitter:image' property='twitter:image' content={image.url} />}
      <meta name='twitter:card' content='summary_large_image' />
    </Helmet>
  )
}

export default SEO
